var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C2.0205 9 0 6.9795 0 4.5C0 2.0205 2.0205 2.38419e-07 4.5 2.38419e-07C6.9795 2.38419e-07 9 2.0205 9 4.5C9 6.9795 6.9795 9 4.5 9ZM4.1625 6.3C4.1625 6.4845 4.3155 6.6375 4.5 6.6375C4.6845 6.6375 4.8375 6.4845 4.8375 6.3V4.05C4.8375 3.8655 4.6845 3.7125 4.5 3.7125C4.3155 3.7125 4.1625 3.8655 4.1625 4.05V6.3ZM4.914 2.529C4.8915 2.4705 4.86 2.4255 4.8195 2.3805C4.7745 2.34 4.725 2.3085 4.671 2.286C4.617 2.2635 4.5585 2.25 4.5 2.25C4.4415 2.25 4.383 2.2635 4.329 2.286C4.275 2.3085 4.2255 2.34 4.1805 2.3805C4.14 2.4255 4.1085 2.4705 4.086 2.529C4.0635 2.583 4.05 2.6415 4.05 2.7C4.05 2.7585 4.0635 2.817 4.086 2.871C4.1085 2.925 4.14 2.9745 4.1805 3.0195C4.2255 3.06 4.275 3.0915 4.329 3.114C4.437 3.159 4.563 3.159 4.671 3.114C4.725 3.0915 4.7745 3.06 4.8195 3.0195C4.86 2.9745 4.8915 2.925 4.914 2.871C4.9365 2.817 4.95 2.7585 4.95 2.7C4.95 2.6415 4.9365 2.583 4.914 2.529Z",
    fill: "#969BA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.b433cae5.svg";
export { ForwardRef as ReactComponent };